import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { FaqAccordion } from "@/components/FaqAccordion";
import { Reveal } from "@/components/Reveal";

export default function Faq() {
  return (
    <div data-testid="faq-page">
      <PageHero overline="FAQ" title="Everything you need to know." subtitle="Still curious? Reach out anytime — we're happy to help you plan your move." />
      <section className="mx-auto max-w-3xl px-6 md:px-12 pb-16">
        <Reveal><FaqAccordion /></Reveal>
      </section>
      <section className="mx-auto max-w-3xl px-6 md:px-12 pb-24 md:pb-32">
        <Reveal>
          <div className="rounded-2xl bg-crate-yellow p-8 md:p-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <h2 className="font-heading font-black text-2xl md:text-3xl text-crate-black tracking-tight">Still have questions?</h2>
              <p className="text-crate-black/70 mt-2">Our team is one message away.</p>
            </div>
            <Link to="/contact" className="inline-flex items-center gap-2 rounded-full bg-crate-black text-white font-bold px-7 py-3.5 hover:bg-white hover:text-crate-black transition-colors shrink-0" data-testid="faq-contact-btn">
              Contact Us <ArrowRight className="h-5 w-5" />
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
